import React, { useEffect, useState } from "react";

import Iconfont from "@components/iconfont/iconfont";

import { scrollPageToTop } from "./scrollTop";

import "./BackTopButton.less";

/**
 * 资讯（列表 / 详情）共用的「回到顶部」悬浮按钮。
 *
 * 规则：页面不是滚到最顶（`window.scrollY > 0`）就出现，点一下同步回顶部。
 * 列表页还有「到底提示出现就让位」的额外规则，由页面通过 `hidden` 传入。
 *
 * 挂在视口右下角（fixed），不占文档流，列表页 / 详情页都可以直接放在根节点里。
 */
export default function BackTopButton({ hidden = false }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let raf = 0;

    const update = () => {
      raf = 0;
      setVisible(window.scrollY > 0);
    };

    const onScroll = () => {
      if (!raf) raf = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, []);

  if (!visible || hidden) return null;

  return (
    <button
      type="button"
      className="m-news-back-top"
      aria-label="回到顶部"
      onClick={scrollPageToTop}
    >
      <Iconfont
        type="icon-a-jiantouxiangshangxi"
        className="m-news-back-top__icon"
      />
    </button>
  );
}
